import { Component } from 'react';
import MainPageImage from '../components/MainPageImage';
import '../App.css';

class Homepage extends Component {
  render() {
    return (
      <div className="Homepage">
        <header className="Homepage-header">
          <MainPageImage />
        </header>
        <div className="bio">
          <p>I am a Staff Software Engineer from Cambridge, Massachusetts with over seven years of experience working for industry-leading software companies. I also think I'm incredibly funny, so if you're on the fence about reaching out, maybe that will help.</p>
        </div>
        <div className="homepage-disclaimer-container">
          <p className="homepage-disclaimer">*This site was built with React. Practical? No. Possible? Yes.</p>
          <p className="homepage-disclaimer">*No one with a sense for aesthetics was consulted in the making of this website.</p>
        </div>
      </div>
    );
  }
}

export default Homepage;
